module.exports = {"pagination":{"ListEventSourceMappings":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"EventSourceMappings"},"ListFunctions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Functions"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/lambda-2015-03-31.paginators.json
// module id = 394
// module chunks = 1